import axios from "axios";

const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;

const ActivityService = {
    list: async (filters = {}) => axios.post(`${API_DESPACHO}/activity/list`, filters).then(({data}) => data.data).catch((err) => { throw err }),

    get: async (id) => axios.get(`${API_DESPACHO}/activity/${id}`).then(({data}) => data).catch((err) => { throw err }),

    garrisonsByDate: async (dateOnDuty) => axios.get(`${API_DESPACHO}/activity/getGarrisonListByActivityDate/?dateOnDuty=${dateOnDuty}`).then(({data}) => data).catch((err) => { throw err }),

    activityItems: async (garrisonIdList) => axios.get(`${API_DESPACHO}/activity/getActivityItems/?garrisonIdList=${garrisonIdList}`).then(({data}) => data).catch((err) => { throw err }),

    save: async (data) => axios.post(`${API_DESPACHO}/activity`, data).then(({data}) => data).catch((err) => { throw err }),

    update: async (id, data) => axios.put(`${API_DESPACHO}/activity/${id}`, data).then(({data}) => data).catch((err) => { throw err }),

    destroy: async (id) => axios.delete(`${API_DESPACHO}/activity/${id}`).then(({data}) => data).catch((err) => { throw err }),
};

export default ActivityService;
